<template>
  <div>
    <section class="hero has-shadow is-grey-ligth" id="headerClima">
      <div class="hero-head" style="margin-bottom: 20px;">
        <br />
        <div
          class="container is-flex is-justify-between"
          style="align-items: center; margin: 0px 25px 0 13px;"
        >
          <h1
            class="title has-text-weight-bold has-text-dark is-2"
            style="margin-bottom: 0; text-wrap: nowrap;"
          >
            CL7
          </h1>
          <div
            v-if="tokenUser && tokenUser.admin"
            class="text-card"
            v-tooltip.bottom="{
              content: empresa.nombre,
              trigger: isMovil ? 'click' : 'manual',
            }"
          >
            <span class="is-size-6 w-full truncate">{{ empresa.nombre }}</span>
            <p
              v-if="proceso.nombre !== '.....'"
              class="is-size-5 has-text-weight-bold truncate"
            >
              {{ proceso.nombre }}
            </p>
          </div>
        </div>
      </div>
      <div class="hero-foot">
        <!-- Menu -->
        <nav class="tabs is-boxed">
          <div class="container">
            <ul v-if="!isMovil">
              <li
                v-bind:class="{ 'is-active': activo('yProceso') }"
                @click="selectSection({ d: 'yProceso', name: 'Proceso' })"
              >
                <a href="#">Proceso</a>
              </li>
              <li
                v-bind:class="{ 'is-active': activo('yEmpleadosn') }"
                @click="selectSection({ d: 'yEmpleadosn', name: 'Empleados' })"
              >
                <a href="#">Empleados</a>
              </li>
              <li
                v-bind:class="{ 'is-active': activo('yEncuestas') }"
                @click="selectSection({ d: 'yEncuestas', name: 'Encuestas' })"
              >
                <a href="#">Encuestas</a>
              </li>
              <li
                v-bind:class="{
                  'is-active': activo('yResultado') || activo('yGuide'),
                }"
                @click="selectSection({ d: 'yGuide', name: 'Resultados' })"
              >
                <a href="#">Resultados</a>
              </li>
              <li
                v-bind:class="{ 'is-active': activo('yFiles') }"
                @click="selectSection({ d: 'yFiles', name: 'Anexos' })"
              >
                <a href="#">Anexos</a>
              </li>
            </ul>
            <ul v-if="isMovil">
              <li
                class="is-active"
                v-on:click="showMenuMobile = !showMenuMobile"
              >
                <a href="javascript:void(0)" class="is-flex">
                  {{ title }}
                  <span class="icon is-small">
                    <i class="material-icons">expand_more</i>
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </section>
    <div
      style="display: flex;
      justify-content: left;
      margin-left: 40px;
      text-align: center;"
    >
      <!-- Mobile -->
      <div
        v-if="isMovil"
        class="dropdown"
        :class="showMenuMobile ? 'is-active' : ''"
      >
        <div class="dropdown-menu" role="menu">
          <div class="dropdown-content">
            <a
              href="#"
              class="dropdown-item"
              v-bind:class="{ 'is-active': activo('yProceso') }"
              @click="
                selectSection({ d: 'yProceso', step: 0, name: 'Proceso' })
              "
            >
              Proceso
            </a>
            <a
              href="#"
              class="dropdown-item"
              v-bind:class="{ 'is-active': activo('yEmpleadosn') }"
              @click="
                selectSection({ d: 'yEmpleadosn', step: 1, name: 'Empleados' })
              "
            >
              Empleados
            </a>
            <a
              href="#"
              class="dropdown-item"
              v-bind:class="{ 'is-active': activo('yEncuestas') }"
              @click="
                selectSection({ d: 'yEncuestas', step: 2, name: 'Encuestas' })
              "
            >
              Encuestas
            </a>
            <a
              href="#"
              class="dropdown-item"
              v-bind:class="{
                'is-active': activo('yResultado') || activo('yGuide'),
              }"
              @click="
                selectSection({ d: 'yGuide', step: 4, name: 'Resultados' })
              "
            >
              Resultados
            </a>
            <a
              href="#"
              class="dropdown-item"
              v-bind:class="{ 'is-active': activo('yFiles') }"
              @click="selectSection({ d: 'yFiles', step: 5, name: 'Anexos' })"
            >
              Anexos
            </a>
          </div>
        </div>
      </div>
    </div>
    <section
      class="is-fullheight is-fullwidth"
      :class="{ colums: !activo('yGuide') }"
      style="transition: all 0.3s ease 0s !important;"
    >
      <div
        :class="{ 'container colum': !activo('yGuide') }"
        style="transition: all 0.3s ease 0s !important;"
      >
        <div
          :class="{
            container: !activo('yGuide'),
            'container-guie': activo('yGuide'),
          }"
        >
          <component
            ref="content"
            :is="select"
            :proceso="proceso"
            :process="proceso"
            :tokenUser="tokenUser"
            @selproceso="selproceso"
            @selectSection="selectSection"
          ></component>
        </div>
        <y-interpretations v-if="select === 'yResultado'"></y-interpretations>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";
import yProceso from "@/components/climan/Process.vue";
import yEmpleadosn from "@/components/climan/Employees.vue";
import yEncuestas from "@/components/climan/Surveys.vue";
import yResultado from "@/components/climan/Resultadosclima.vue";
import yFiles from "@/components/attached/uploadFilesBoard.vue";
import yGuide from "@/components/climan/GuiaInterpretacion.vue";
import yInterpretations from "./MenuInterpretations.vue";

export default {
  data() {
    return {
      select: "yProceso",
      title: "Proceso",
      proceso: {
        nombre: ".....",
      },
      showMenuMobile: false,
    };
  },
  computed: {
    ...mapState(["tokenUser", "isOculto", "isMovil", "empresa"]),
  },
  methods: {
    selproceso(d, p) {
      this.proceso = d;
      if (Object.keys(p).length > 0) {
        this.proceso.processComp = p;
      }
      // Serie completa para el render multi-proceso de Resultados. `processComp`
      // se mantiene como el proceso anterior inmediato para lo que ya existe.
      this.proceso.historic = d.historic || (p._id ? [p] : []);
      if (this.select === "yProceso") {
        setTimeout(
          this.selectSection({ d: "yEmpleadosn", name: "Empleados" }),
          5000,
        );
      }
    },
    selectSection({ d, name }) {
      if (this.proceso.nombre !== ".....") {
        this.select = d;
        this.title = name;
        this.closeMenuMobile();
      } else {
        this.$store.dispatch("notify", {
          message: `Selecciona un proceso`,
          type: "is-danger",
        });
        this.closeMenuMobile();
      }
    },
    activo(a) {
      if (a === this.select) {
        return true;
      } else {
        return false;
      }
    },
    closeMenuMobile() {
      this.showMenuMobile = false;
    },
  },
  watch: {
    isOculto(nv) {
      if (nv) {
        this.showMenu = false;
      }
    },
    select(nv) {
      if (nv !== "yResultado") {
        this.showMenu = false;
      }
    },
    showMenu(nv) {
      if (nv && !this.isOculto) {
        this.$store.commit("ocultarSide");
      }
    },
    closeMenuMobile() {
      this.showMenuMobile = false;
    },
  },
  components: {
    yProceso,
    yEmpleadosn,
    yEncuestas,
    yResultado,
    yFiles,
    yGuide,
    yInterpretations,
  },
};
</script>

<style lang="scss" scoped>
.contenedor {
  width: 100%;
  position: absolute;
  z-index: 1;
}

.contenedor2 {
  width: 90%;
  position: absolute;
  z-index: 1;
}

.container-guie {
  margin-top: 10px;
}

a.dropdown-item.is-active,
button.dropdown-item.is-active {
  background-color: #522687;
  color: #fff;
}

.tabs.is-toggle li.is-active a {
  background-color: #522687;
  border-color: #905fbf;
  color: white;
  z-index: 1;
}

.hero.is-grey-ligth {
  padding-left: 40px;
}

.hero.is-grey-ligth .tabs.is-boxed li.is-active a {
  background-color: white;
  border: solid 0 white;
  color: #522687 !important;
  box-shadow: #00000029 0px 14px 20px;
}

.hero.is-grey-ligth .tabs.is-boxed li:hover a {
  background-color: rgba(191, 191, 191, 0.475);
  border: solid 0 rgba(191, 191, 191, 0.475) !important;
  color: #522687 !important;
}

.hero.is-grey-ligth .tabs.is-boxed a {
  border: 0px solid transparent;
  border-radius: 4px 4px 0 0;
}

.button-Clima-closed {
  position: fixed;
  top: 47px;
  padding: 15px;
  margin-left: 91.5%;
  transition: all 0.3s ease 0s;
  z-index: 61;
}

.button-Clima-open {
  position: fixed;
  top: 47px;
  padding: 15px;
  margin-left: 74.5% !important;
  transition: all 0.3s ease 0s;
  z-index: 61;
}

/* Backgrounds */

.rango1 {
  background-color: var(--clima-1) !important;
  color: white !important;
}

.rango2 {
  background-color: var(--clima-2) !important;
  color: rgba(65, 64, 64, 0.91);
}

.rango3 {
  background-color: var(--clima-3) !important;
  color: rgba(65, 64, 64, 0.91);
}

.rango4 {
  background-color: var(--clima-4) !important; // f7d774a
  color: rgba(65, 64, 64, 0.91);
}

.rango5 {
  background-color: var(--clima-5) !important;
  color: rgba(65, 64, 64, 0.91);
}

.rango6 {
  background-color: var(--clima-6) !important;
  color: rgba(65, 64, 64, 0.91);
}

.rango0 {
  background-color: rgba(175, 174, 174, 0.8);
}

.text-justify {
  text-align: center !important;
  text-justify: inter-word !important;
}

.text-card {
  padding: 3px 10px;
  border-radius: 10px;
  background-color: white;
}

@media (max-width: 768px) {
  .text-card {
    max-width: 55vw;
    min-width: 0;

    .truncate {
      display: block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .title.is-2 {
      font-size: 2rem !important;
    }

    .is-size-6,
    .is-size-5 {
      font-size: 0.75rem !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/climan/Menuclima.vue